var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card mb-4",
      class: [_vm.anyErrorsForAnyLang ? "border-error" : "border-normal"]
    },
    [
      _c("div", { staticClass: "card-header" }, [
        _c(
          "ul",
          {
            staticClass: "nav nav-tabs card-header-tabs",
            attrs: { id: "equipment" }
          },
          _vm._l(_vm.languages, function(lang) {
            return _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link text-primary cursor-pointer",
                  class: [
                    _vm.language === lang ? "active" : "",
                    _vm.anyErrorsForLang(lang)
                      ? "text-danger font-weight-bold"
                      : "text-primary"
                  ],
                  on: {
                    click: function($event) {
                      _vm.language = lang
                      _vm.$emit("update:language", _vm.language)
                    }
                  }
                },
                [
                  _vm.anyErrorsForLang(lang)
                    ? _c("i", {
                        staticClass:
                          "font-weight-bold mdi mdi-alert text-danger"
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("lang." + lang)) +
                      "\n                "
                  )
                ]
              )
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }